/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';
import { IMicrocycle, IPrewod, IMicrocycleError } from "../../../containers/FitnessPlan/FitnessTemplate/interface";
import _ = require("lodash");
import { MicrocyleDayTab } from "./MicrocycleDayTab/MicrocyleDayTab";
import { WorkoutWidget } from "./WorkoutWidget/WorkoutWidget";
import { getInitialWodValues } from "../../../containers/FitnessPlan/FitnessTemplate/helper";
import { RestDay } from "./RestDay/RestDay";
import { WORKOUT_FOCUS } from "../../../containers/FitnessPlan/constants";
import { ISelectOption } from "../../common/SearchableSelect/SearchableSelect";


interface IMicrocyleTemplateProps {
    microcycleData: IMicrocycle;
    setMicrocyleData: (microcycleData: IMicrocycle) => void;
    exerciseList: ISelectOption[];
    errorStates: IMicrocycleError[];
    isViewMode: boolean;
}

export const MicrocyleTemplate: React.FC<IMicrocyleTemplateProps> = (props: IMicrocyleTemplateProps) => {
    const { microcycleData, setMicrocyleData, isViewMode, exerciseList, errorStates } = props;

    const [selectedDay, setSelectedDay] = React.useState(0);

    const preWods = _.get(microcycleData, 'prewods', []);

    const groupedPrewods = preWods && _.groupBy(preWods, (item) => item.dayOfCycle);

    const selectedDayErrors = errorStates && errorStates.filter(({ day }) => day === selectedDay);

    let selectedDayWod: IPrewod = groupedPrewods && groupedPrewods[selectedDay] && groupedPrewods[selectedDay][0];

    const setWorkoutFocus = (selectedFocus: string, isChildOptionSelected?: boolean) => {
        if (isChildOptionSelected) {
            //set selected day workout from selected option
            copyWorkoutFromAnotherDay(selectedFocus)
        } else {
            mapAndUpdatePrewods((preWod: IPrewod) => {
                //clear exercises if rest day is selected
                if (preWod.dayOfCycle === selectedDay) {
                    if (selectedFocus === WORKOUT_FOCUS.RestDay) {
                        return {
                            ...preWod,
                            workoutType: selectedFocus,
                            sets: []
                        }
                    }
                    else {
                        //prefill set values if focus is not rest 
                        return {
                            ...preWod,
                            sets: preWod.sets ? (preWod.sets.length === 0 ? getInitialWodValues(selectedDay).sets : preWod.sets) : getInitialWodValues(selectedDay).sets,
                            workoutType: selectedFocus,
                        };
                    }

                }
                return preWod;
            });

        }
    }

    const copyWorkoutFromAnotherDay = (copyFromDayValue: string | number) => {
        const copiedPrewods = [...microcycleData.prewods];
        //slice selected day data

        const selectedDayIndex = copiedPrewods.findIndex(({ dayOfCycle }) => dayOfCycle === selectedDay);
        const selectedDayData = copiedPrewods[selectedDayIndex];
        copiedPrewods.splice(selectedDayIndex, 1);

        //copy to selected day
        let copiedWorkoutDetails: IPrewod = { ...copiedPrewods.find(({ dayOfCycle }) => dayOfCycle === copyFromDayValue) };

        //delete ids
        copiedWorkoutDetails.id = selectedDayData.id;
        delete copiedWorkoutDetails.createdOn;
        delete copiedWorkoutDetails.lastModifiedOn;
        copiedWorkoutDetails.sets.map(set => {
            set.managedPreWodId = selectedDayData.id;
            delete set.id;
            delete set.createdOn;
            delete set.lastModifiedOn;

            set.managedExercises.map(exercise => {
                delete exercise.id;
                delete exercise.managedWorkoutSetId;
                delete set.createdOn;
                delete set.lastModifiedOn;
            })
        })

        copiedPrewods.push({ ...copiedWorkoutDetails, dayOfCycle: selectedDay });
        setMicrocyleData({
            ...microcycleData,
            prewods: copiedPrewods,
        })
    }

    const mapAndUpdatePrewods = (mapperFn: any) => {
        const copiedPrewods = [...microcycleData.prewods];
        const transformedPreWods = copiedPrewods.map((preWod: IPrewod) =>
            mapperFn(preWod),
        );
        setMicrocyleData({
            ...microcycleData,
            prewods: transformedPreWods,
        });
    };

    //update workout sets values along with exercises
    const setMicrocyleDataForSelectedDay = (data: any) => {
        mapAndUpdatePrewods((preWod: IPrewod) => {
            if (preWod.dayOfCycle === selectedDay) {
                return {
                    ...preWod,
                    sets: data,
                };
            }
            return preWod;
        });
    }


    return (
        <React.Fragment>
            {
                selectedDayWod &&
                <section css={styles.microcycleWrapper}>
                    <MicrocyleDayTab selectedDay={selectedDay} setSelectedDay={setSelectedDay} setWorkoutFocus={setWorkoutFocus} groupedPrewods={groupedPrewods} errorStates={errorStates} isViewMode={isViewMode} />
                    <div css={styles.wodOuterWrapper}>
                        {
                            selectedDayWod.workoutType === "Rest Day" ?
                                <RestDay /> :
                                <WorkoutWidget selectedDayWods={selectedDayWod} exerciseList={exerciseList} setMicrocyleDataForSelectedDay={setMicrocyleDataForSelectedDay} errorStates={selectedDayErrors} isViewMode={isViewMode} />
                        }
                    </div>
                </section>
            }
        </React.Fragment>

    )
}